import React, { useState, useEffect } from "react";
import {
    Button,
    Card,
    Container,
    Row,
    Col,
    Form,
    Modal,
} from "react-bootstrap";
import InputMask from "react-input-mask";
import LoadingOverlay from "react-loading-overlay";
import { useParams } from "react-router-dom";
import { MainService } from "../../services/MainService";
import "./index.css";

function Home() {
    const [loader, setLoader] = useState(true);
    const [survey, setSurvey] = useState(null);
    const [questions, setQuestions] = useState([]);
    const [answered, setAnswered] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [titleModal, setTitleModal] = useState("");
    const [messageModal, setMessageModal] = useState("");
    const [buttonSendClicked, setButtonSendClicked] = useState(false);

    const { surveyId } = useParams();

    useEffect(() => {
        async function load() {
            if (surveyId) {
                const surveyResponse = await MainService.loadQuestions(
                    surveyId
                );
                if (surveyResponse) {
                    if (surveyResponse.answered) {
                        setAnswered(true);
                    } else {
                        setSurvey(surveyResponse);

                        let questionsMapped = [
                            ...surveyResponse.form.questions,
                        ];
                        questionsMapped = questionsMapped.map((question) => ({
                            ...question,
                            answer: "",
                        }));
                        setQuestions(questionsMapped);
                    }
                } else {
                    alert("Pesquisa não encontrada.");
                    window.location = "https://www.gazin.com.br/";
                }
            } else {
                alert("Pesquisa não encontrada.");
                window.location = "https://www.gazin.com.br/";
            }

            setLoader(false);
        }

        load();
    }, []);

    // useEffect(() => {
    //     async function load() {
    //         const branchTabloid = await MainService.getTabloidIfExists(
    //             branch._id
    //         );
    //         setBranchTabloid(branchTabloid);
    //     }

    //     load();
    // }, [branch]);

    const showObjectiveOrDiscursive = (question, indexQuestion) => {
        if (question.type === "OBJECTIVE") {
            return showAnswers(question.answers, indexQuestion);
        } else {
            return (
                <Form.Group controlId="textareaResponse">
                    <Form.Label>Escreva sua resposta abaixo</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={3}
                        value={questions[indexQuestion].answer}
                        onChange={(event) => {
                            let newQuestions = [...questions];
                            newQuestions[indexQuestion].answer =
                                event.target.value;
                            setQuestions(newQuestions);
                        }}
                    />
                </Form.Group>
            );
        }
    };

    const showAnswers = (answers, indexQuestion) => {
        return (
            <ul className="list-unstyled">
                {answers.map((answer, index) => (
                    <li key={index}>
                        <Form.Check
                            type="radio"
                            label={`${answer.title}`}
                            value={answer.id}
                            checked={
                                questions[indexQuestion].answer === answer.id
                            }
                            onChange={(event) => {
                                let newQuestions = [...questions];
                                newQuestions[indexQuestion].answer = parseInt(
                                    event.target.value
                                );
                                setQuestions(newQuestions);
                            }}
                        />
                    </li>
                ))}
            </ul>
        );
    };

    const sendAnswers = async () => {
        setLoader(true);

        let answersToSave = [];
        for (const question of questions) {
            if (!question.answer) {
                setTitleModal("Respostas obrigatórias");
                setMessageModal("Por favor, responda todas as perguntas.");
                setShowModal(true);
                setLoader(false);
                return;
            }

            if (question.type === "OBJECTIVE") {
                answersToSave.push({
                    formQuestion: question.id,
                    formQuestionAnswer: question.answer,
                });
            } else {
                answersToSave.push({
                    formQuestion: question.id,
                    discursiveAnswer: question.answer,
                });
            }
        }
        console.log(answersToSave);

        const saveAnswersResponse = await MainService.saveAnswers(
            surveyId,
            answersToSave
        );
        setLoader(false);

        if (saveAnswersResponse) {
            setTitleModal("Obrigado!");
            setMessageModal("Obrigado por responder à pesquisa!");
            setShowModal(true);

            setTimeout(() => {
                window.location = "https://www.gazin.com.br/";
            }, 2000);
        } else {
            setTitleModal("Ops!");
            setMessageModal(
                "Ops! Tivemos um problema em salvar suas resposta. Por favor, tente novamente."
            );
            setShowModal(true);
            setButtonSendClicked(false);
        }
    };

    const getFirstName = (name) => {
        if (name) {
            let firstName = name.toLowerCase();
            if (firstName.split(" ").length > 1) {
                firstName = firstName.split(" ")[0];
            }

            return firstName.charAt(0).toUpperCase() + firstName.slice(1);
        } else {
            return "";
        }
    };

    return (
        <>
            <LoadingOverlay active={loader} spinner text="Buscando...">
                <Modal show={showModal} onHide={() => setShowModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>{titleModal}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{messageModal}</Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="primary"
                            onClick={() => setShowModal(false)}
                        >
                            Fechar
                        </Button>
                    </Modal.Footer>
                </Modal>
                {!answered && survey ? (
                    <Container className="containerBackground2">
                        <Row>
                            <Col xs="12" md="12">
                                <div className="gazin-logo">
                                    <img
                                        src="https://www.gazin.com.br/images/svg/new-logo.svg"
                                        alt="Gazin Logo"
                                        width="350"
                                    />
                                </div>
                                <div className="welcome-tabloid">
                                    <h2>
                                        Olá, {getFirstName(survey.client?.name)}
                                        !
                                    </h2>
                                </div>
                                <p
                                    style={{
                                        marginTop: 10,
                                    }}
                                    className="textWelcome"
                                >
                                    É um privilégio servir clientes como você. A
                                    Gazin será sempre a sua casa. Aceite o nosso
                                    agradecimento sincero pela sua preferência!
                                    Por favor responda as questões abaixo para
                                    aperfeiçoarmos cada vez mais nossos
                                    processos, sua opinião é muito importante
                                    pra nós.
                                </p>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs="12" md="12">
                                {questions.map((question, index) => (
                                    <Card
                                        style={{
                                            marginTop: 20,
                                        }}
                                    >
                                        <Card.Header>
                                            {index + 1}. {question.title}
                                        </Card.Header>
                                        <Card.Body>
                                            <Card.Text>
                                                {showObjectiveOrDiscursive(
                                                    question,
                                                    index
                                                )}
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                ))}
                            </Col>
                        </Row>
                        <Row>
                            <Col xs="12" md="12">
                                <Button
                                    variant={
                                        buttonSendClicked
                                            ? "secondary"
                                            : "success"
                                    }
                                    style={{
                                        marginTop: 20,
                                    }}
                                    onClick={() => {
                                        if (!buttonSendClicked) {
                                            sendAnswers();
                                            setButtonSendClicked(true);
                                        }
                                    }}
                                >
                                    Enviar respostas!
                                </Button>
                            </Col>
                        </Row>
                    </Container>
                ) : answered && survey === null ? (
                    <Container className="containerBackground2">
                        <Row>
                            <Col xs="12" md="12">
                                <div className="gazin-logo">
                                    <img
                                        src="https://www.gazin.com.br/images/svg/new-logo.svg"
                                        alt="Gazin Logo"
                                        width="350"
                                    />
                                </div>
                                <div className="welcome-tabloid">
                                    <h2>Olá, você já respondeu à pesquisa!</h2>
                                </div>
                                <p
                                    style={{
                                        marginTop: 10,
                                    }}
                                    className="textWelcome"
                                >
                                    É um privilégio servir clientes como você. A
                                    Gazin será sempre a sua casa. Aceite o nosso
                                    agradecimento sincero pela sua preferência!
                                </p>
                            </Col>
                        </Row>
                    </Container>
                ) : null}
            </LoadingOverlay>
        </>
    );
}

export default Home;
